








































import Vue from 'vue'
import Component from 'vue-class-component'
import {State} from 'vuex-class'
import WidgetType from '@/modules/widget/model/WidgetType'

/**
 * Catalogo de widgets
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component
export default class WidgetCatalog extends Vue {
    /**
     * Indica si el componente se encuentra activo
     */
    @State(state => state.widget.widgetCatalog)
    public active: boolean

    /**
     * Lista de tipos de widgets registrados en la aplicación
     */
    @State(state => state.widget.widgetTypes)
    public types: WidgetType[]
}
